import {
  ACTION_CANCEL_PAYOUT_REQUEST__REQUEST,
  ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  ACTION_CANCEL_PAYOUT_REQUEST__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CANCEL_PAYOUT_REQUEST__REQUEST:
    case ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS:
      return null;

    case ACTION_CANCEL_PAYOUT_REQUEST__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
